import api from "./api";

export default class PermissionsAPI {
    static getPermissions = async (id: any) => {
        const response = await api.get(`/ClientePermissoes/${id}`);
        return response.data;
    }

    static getSysPermissions = async (page: number, recordsPerPage: number) => {
        const response = await api.get(`/sysPermissoes?Page=${page}&RecordsPerPage=${recordsPerPage}`);
        return response.data;
    }
};